<template>
	<article v-if="campaign">
		<div v-if="campaignIsActive" style="position: relative">
			<h1 v-if="campaign.displayName" class="pt-5 pl-5">{{ campaign.seoName || campaign.name }}</h1>
			<html-description
				class="campaign-description"
				ref="description"
				:html="campaign.description"
				:iframeReziser="resizeIframe"
				@html-loaded="triggerInjects"
				@iframeHeight="setIframeHeight"
			/>
			<div class="clearfix" />
		</div>
		<div v-else>
			<h1 class="pt-5 pl-5">Denna kampanj är tyvärr avslutad :(</h1>
		</div>
		<product-browser
			v-show="showBrowser"
			ref="browser"
			:layoutOptions="{ compactLayout: true, compactThreshold: 10 }"
			:campaign="campaign"
			:passFallback="campaign ? campaign.passParameter : null"
			:url="'campaign/' + campaign.id"
			:totalProductCount.sync="totalProductCount"
			:totalProductCountSet.sync="totalProductCountSet"
			:resetData="resetData"
			@loaded="onPageLoad"
		/>
		<html-description
			v-if="campaignIsActive"
			class="campaign-description second-description"
			ref="secondDescription"
			:html="campaign.secondDescription"
		/>
		<modal v-model="modalOpen" name="becomeMember">
			<member-form
				class="add-to-wislisht-member-form"
				:showCloseButton="false"
				value="register"
			/>
		</modal>
	</article>
</template>

<script>
import { debounce } from 'lodash';
import mq from 'mediaQuery';
import Vue from 'vue';
import waja from 'waja';
import bus from 'eventbus';
import router from 'router';
import store from 'datastore';
import metaHandler from 'metaHandler';
import { setSectionAndCategories } from 'datastore/navStatus';
import { error, urlFormat } from 'utils';
import { mapGetters } from 'vuex';
import countdownTimer from '../countdown-timer.vue';
import topListSlider from '../top-list-slider.vue';

export default {
	handlesPrerender: true,
	willSendScrollTriggerEvent: true,
	handlesMeta: true,
	handleTakeovers: true,
	handleNavigation () {
		return true;
	},
	layoutOptions: {
		leftCol: true,
	},
	data () {
		return {
			mq,
			campaign: null,
			memberButton: null,
			modalOpen: false,
			hideBrowser: false,
			defaultLayout: {
				leftCol: true,
			},
			totalProductCount: 0,
			totalProductCountSet: false,
			resetData: [],
		};
	},
	beforeRouteEnter (to, frm, next) {
		const data = {};
		if (to.query.pass) {
			data.pass = to.query.pass;
		}
		waja.get('campaign/' + to.params.id + '/' + store.getters['i18n/regionCode'])
			.data(data)
			.useCdn(true)
			.on('success', res => {
				if (! res.data.campaign.active) {
					next(error(404, 'Denna kampanj är tyvärr avslutad', res.data));
					return;
				}

				next(vm => {
					vm.campaign = res.data.campaign;
					vm.campaign.takeover = res.data.takeover;
				});
			})
			.on('404', res => {
				res.text().then(text => {
					try {
						const json = JSON.parse(text);
						let data;
						if (json instanceof Object) {
							data = json;
						}

						next(error(404, 'Kampanjen kunde inte hittas', data));

					} catch (e) {
						// Response isn't json.
						next(error(404, 'Kampanjen kunde inte hittas', {}));
					}
				});
			})
			.on('error', () => {
				next(error(500, 'Det går för tillfället inte att komma åt denna sida. Försök gärna senare.'));
			}).go();
	},
	beforeDestroy () {
		if (this.memberButton) {
			this.memberButton.removeEventListener("click", this.handleMemberButtonClick, false);
		}
	},
	computed: {
		showBrowser () {
			return this.campaignIsActive && this.totalProductCount > 0;
		},
		/**
		* True if the campaign is active. True when the campaign has not
		* been loaded yet (if it is null).
		*/
		campaignIsActive () {
			if (this.campaign) {
				if (! this.campaign.active) {
					return false;
				}
				return true;
			}
			return false;
		},
		/**
		 * Add campaign ID's that you want to use the resize function
		 * Make sure to add ID 'iFrameResizer' to iframe in campaign tool
		*/
		resizeIframe () {
			/**
			 * 8609 = Linksys
			 * 8984 = Trade in / Revive
			 */
			if (this.campaign.id === 8609 || this.campaign.id === 8984) {
				return true;
			} else {
				return false;
			}
		},
		...mapGetters ({
			isLoggedIn: 'user/isLoggedIn',
		}),
	},
	methods: {
		triggerInjects () {
			this.injectCountdown();
			this.injectToplist();

			this.memberButton = document.getElementById("becomeMember");
			if (this.memberButton?.addEventListener) {
				this.memberButton.addEventListener("click", this.handleMemberButtonClick, false);
			}
			if (this.memberButton && this.isLoggedIn) {
				this.memberButton.style.display = 'none';
			}
		},
		forceUpdate () {
			this.$router.go();
		},
		onPageLoad () {
			store.dispatch('prerender/pageLoaded');
		},
		redirectToCampaign(id) {
			router.updateParams({
				id: id,
			});
		},
		updateLayout: debounce(function (campaign) {
			this.updateTakeover(campaign);
			// Hide left column.
			const layout = Object.assign({}, this.defaultLayout, campaign.layoutOptions);
			if (this.totalProductCount <= 10 && this.totalProductCountSet) {
				// Visa inte vänsterkolumnen om det finns färre än 10 produkter i kampanjen
				layout.leftCol = false;
			}
			bus.$emit('layout:update', layout);
		}, 200),
		updateTakeover (campaign) {
			let takeover = null;

			if (campaign.takeover) {
				takeover = campaign.takeover;
			}

			// Check if the campaign has explicitly set a custom takeover image.
			// The custom takeover is not shown when the campaign is inactive.
			if (campaign.takeoverUrl && campaign.takeoverUrl !== '' && campaign.active) {
				bus.$emit('takeover:update', {
					campaign: campaign,
					imageUrl: campaign.takeoverUrl,
				});
			} else if (takeover) {
				bus.$emit('takeover:update', takeover);
			}
		},
		enableJS () {
			const scriptTags = document.querySelectorAll('.campaign-description script');
			for (const tag of scriptTags) {
				eval(tag.innerHTML);
			}
		},
		openLightbox (ev) {
			console.log('OPEN LIGHTBOX', ev);
			const html = '<img src='+ev.target.src+' style=\'max-height: 85vh; max-width: 100%\'>';
			bus.$emit('modal.html', html, 'lightbox-modal');
		},
		enableLightbox () {
			const tags = document.querySelectorAll('.campaign-description img.lightbox');
			for (const tag of tags) {
				tag.onclick = this.openLightbox;
				// @TODO add cursor
			}
		},
		applyFulhax (campaign) {
			this.enableLightbox();
			if (campaign.id === 3777) { // BOSE-JS
				const script = document.createElement('script');
				script.setAttribute('src', 'https://assets.bose-sis.com/js/iframeResizer.min.js');
				script.onload = () => {
					script.parentNode.removeChild(script);
				};
				document.head.appendChild(script);
			}
			if (campaign.id === 9480) { // LEGO
				const script = document.createElement('script');
				script.setAttribute('src', 'https://tiger-cdn.zoovu.com/advisor-fe-web/api/v1/advisors/zkQVP3rm/js-loader?locale=sv-SE');
				script.onload = () => {
					script.parentNode.removeChild(script);
				};
				document.head.appendChild(script);
			}
			if (campaign.id === 10532) { // LEGO NYTT - så nya partner kan utveckla
				const script = document.createElement('script');
				script.setAttribute('src', 'https://cdn-igs-prd.conversity.com/static/js/igs-public/entrypoint.js');
				script.setAttribute('class', 'com_realtimerelevance');
				script.setAttribute('type', 'application/javascript');
				script.setAttribute('data-client-id', '6cbfda4f95b14bbf9ea06d5fdb0a3e73');
				this.applyLegoScript(script);
			}
			if (campaign.id === 7402 || campaign.id === 8609) { // Fraudium & linksys
				this.enableJS();
			}

			if (campaign.id === 7750) { // WH 20 år £¢¼#¢⅝ dropdowns på ios
				setTimeout(() => {
					const dropdownTags = document.querySelectorAll('.bf-content .bf-content-row > li');
					for (const tag of dropdownTags) {
						tag.onclick = function () {};
						tag.touchstart = function () {};
					}
				}, 100); // @TODO varför räcker inte nexttick längre? vue-bugg? undersök
			}
		},
		applyLegoScript (script) {
			if (document.getElementById('legoGiftFinder')) {
				document.getElementById('legoGiftFinder').appendChild(script);
			} else {
				setTimeout(() => {
					this.applyLegoScript(script);
				}, 100);
			}
		},
		injectCountdown () {
			const countdownTags = document.querySelectorAll('.countdown');
			if (countdownTags.length > 0) {
				const countdownTargetTime = new Date(countdownTags[0].innerHTML);
				const now = new Date();

				if (now <= countdownTargetTime) {
					const componentInstance = new Vue( Object.assign({}, countdownTimer, {
						propsData: { targetTime: new Date(countdownTags[0].innerHTML) },
					}));

					componentInstance.$on('countdownend', () => {
						this.forceUpdate();
					});

					componentInstance.$mount('#countdownMountpoint');
				} else {
					countdownTags[0].innerHTML = '';
				}
			}
		},
		injectToplist () {
			const toplistTag = document.querySelectorAll('.topList');

			if (toplistTag.length > 0) {
				for (let i = 0; i < toplistTag.length; i++) {
					const toplistId = Number(toplistTag[i].innerHTML);
					const componentInstance = new Vue( Object.assign({}, topListSlider, {
						store: store,
						router: router,
						propsData: { id: toplistId, singleToplist: true, showDescription: false },
					}));
					componentInstance.$mount('#topListMountpoint-' + toplistId);
				}
			}
		},
		setIframeHeight (height) {
			let iframeContainer = document.getElementById('iFrameResizer');
			iframeContainer.style.height = height + "px";
		},
		handleMemberButtonClick () {
			this.modalOpen = ! this.modalOpen;
		},
	},
	watch: {
		campaign (campaign) {
			router.updateParams({
				id: campaign.id,
				name: urlFormat(campaign.name),
			});

			setSectionAndCategories(campaign.section, []);

			if (campaign.id) {
				this.resetData = [[{
					type: 'campaign',
					value: campaign.id,
				}], true];
				Vue.nextTick(() => {
					this.applyFulhax(campaign);
				});
			} else {
				Vue.nextTick(() => {
					this.applyFulhax(campaign);
					this.onPageLoad();
				});
			}

			if (! campaign.displayLeftCol) {
				campaign.layoutOptions = { leftCol: false };
			}

			this.updateLayout(this.campaign);

			const metaDescription = campaign.metaDescription || 'Kolla in ' + campaign.name +
					' på Webhallen.com. Fri frakt för medlemmar ✓ Öppet köp 30' +
					' dagar ✓ Snabba leveranser - Köp online eller i butik!';

			metaHandler.set('description', metaDescription);
			if (campaign.metaRobotsNoindex) {
				metaHandler.set('robots', 'noindex, follow');
			}
		},
		$route (to, frm) {
			const id = parseInt(to.params.id);

			if (parseInt(frm.params.id) === id) {
				// The layout needs to be updated even when routing from a
				// campaign to itself (to remove left column for instance).
				this.updateLayout(this.campaign);
				return;
			}

			waja.get('campaign/' + id + '/' + store.getters['i18n/regionCode'])
				.useCdn(true)
				.on('success', res => {
					if (parseInt(this.$route.params.id) !== res.data.campaign.id) { // Urlen har ändrats under requesten
						return;
					}
					this.campaign = res.data.campaign;
					this.campaign.takeover = res.data.takeover;
				})
				.on('404', () => {
					error(404, 'Kampanjen kan inte hittas')(this);
				}).go();
		},
		totalProductCount (to, frm) {
			if (to !== frm && this.totalProductCountSet) {
				this.updateLayout(this.campaign);
			}
		},
		isLoggedIn (to) {
			if (this.memberButton) {
				if (to) {
					this.memberButton.style.display = 'none';
					if (this.modalOpen) {
						this.modalOpen = false;
					}
				} else {
					this.memberButton.style.removeProperty('display');
				}
			}
		},
	},
};
</script>
